export default __webpack_public_path__ + "static/media/arrow.147f0971.svg";